import React, { useEffect, useState } from 'react';
import { donePageLoading, setIsStreaming } from '../actions/offer';
import { connect } from 'react-redux';
import OfferPlayer from '../components/OfferComponents/OfferPlayer';
import {getSystemRequirementsFromSettings,getFileData} from '../common/methods/CommonUtil';

function ConfirmVideo(props) {
	// 設定情報（消費税率・動作推奨環境）
	const [settingJson, setSettingJson] = useState(null);
	const [playerUrl, setPlayerUrl] = useState(null);
	const [systemRequirements, setSystemRequirements] = useState()

	useEffect(() => {
		props.setIsStreaming(false);
		props.donePageLoading(true);
		// 設定情報取得
		if (settingJson === null) {getSettingJson();} 
		if (playerUrl === null) {getPlayerUrl();} 
	}, []);

	useEffect(() => {
		getSystemRequirements();
	}, [settingJson])

	const getSettingJson = async() => {
		const url = process.env.REACT_APP_API_DIR_URL + `v1/static/setting`;
		const result = await getFileData(url);
		setSettingJson(result.settings);
	}

	const getSystemRequirements = () => {
		if (!settingJson) {return;}
		let systemRequirements = getSystemRequirementsFromSettings(settingJson);
		setSystemRequirements(systemRequirements);
	}

	const getPlayerUrl = async() => {
		const url = process.env.REACT_APP_API_DIR_URL + `v1/confirm-video/?params=`;
		const result = await getFileData(url);
		setPlayerUrl(result.url);
	}
	
	return (
		<>
			{props.language === 'ja_JP' ? (
				<section className="environment">
					<div className="environment-thumbnail">

						<OfferPlayer
							format={'test'}
							programState={'Streaming'}
							script={playerUrl}
							muxPerformanceTitle={"Check Test Streaming"}
							performanceThumbnail={'./assets/img/common/thumbnail-default.jpg'}
						/>

					</div>
					<div className="environment-content">
						<div className="environment-body">
						<h1 className="environment-title">動画再生確認</h1>
							{systemRequirements && Object.keys(systemRequirements).length ? 
								<>
								<p className="environment-text">以下のWebブラウザーの使用を推奨しています。</p>
								<h2 className="environment-title2">動作確認環境</h2>
								<dl className="environment-info">
									{systemRequirements.Windows || systemRequirements.Mac ? (
										<>
										<dt className="environment-info__title">【PC】</dt>
										{systemRequirements.Windows ? 
											<>
											<div className="environment-info__title">Windows {systemRequirements.Windows.os}</div>
											{systemRequirements.Windows.browserList.map((browser,index) => {
												return (<dd className="environment-info__text" key={index}>・{browser}</dd>)
											})}
											</>
										: ''}
										{systemRequirements.Mac ? 
											<>
											<div className="environment-info__title">macOS Ventura({systemRequirements.Mac.os}以降)</div>
											{systemRequirements.Mac.browserList.map((browser,index) => {
												return (<dd className="environment-info__text" key={index}>・{browser}</dd>)
											})}
											</>
										: ''}
										</>
									):''}
									{systemRequirements.Android || systemRequirements.iOS || systemRequirements.iPad ? (
										<>
										<div className="environment-info__title">【スマートフォン】</div>
										{systemRequirements.Android ? 
											<>
											<div className="detail-info__text-title">Android （Android {systemRequirements.Android.os}以降）</div>
											{systemRequirements.Android.browserList.map((browser,index) => {
												return (<dd className="environment-info__text" key={index}>・{browser}</dd>)
											})}
											</>
										: ''}
										{systemRequirements.iOS && systemRequirements.iPad ? 
											<>
											<div className="environment-info__title">Apple（iOS {systemRequirements.iOS.os}以降、iPadOS {systemRequirements.iPad.os}以降）</div>
											{systemRequirements.iOS.browserList.map((browser,index) => {
												return (<dd className="environment-info__text" key={index}>・{browser}</dd>)
											})}
											</>
										: ''}
										</>
									) : ('')}
								</dl>
								<p className="environment-attention">※推奨環境下でもお客様のwebブラウザの設定によっては、正しく表示されない場合があります。</p>
								<p className="environment-attention">※通信状況、通信能力及びPCのスペック性能によりページの表示に時間がかかる、あるいは正常に動作しない場合があります。</p>
								<p className="environment-attention">※アプリの提供は2023年をもって終了しました。</p>
								<div id="pl_programme_info_text" className="hidden_programme">
									<p>曲目がある場合はこちらに表示されます。</p>
								</div>
								</>
							: ''}
						</div>
						<aside className="environment-side">
							<h2 className="environment-title2">JavaScriptについて</h2>
							<p className="environment-text">当サイトでは、JavaScriptを使用しています。 お使いのブラウザでJavaScript機能を無効にされている場合、正しく機能しない、もしくは正しく表示されないことがあります。 ご覧になる際にはブラウザ設定でJavaScriptを有効にしてご覧ください。</p>
							<h2 className="environment-title2">Cookieについて</h2>
							<p className="environment-text">当サイトでは、Cookieを使用しています。 お使いのブラウザでCookie機能を無効にされている場合、正しく機能しない、もしくは正しく表示されないことがあります。 ご覧になる際にはブラウザ設定でCookieを有効にしてご覧ください。</p>
						</aside>
					</div>
				</section>
			) : (
				<section className="environment">
					<div className="environment-thumbnail">
						<OfferPlayer
							format={'test'}
							programState={'Streaming'}
							script={playerUrl}
							performanceThumbnail={'/assets/img/common/thumbnail-default.jpg'}
						/>
					</div>
					<div className="environment-content">
						<div className="environment-body">
							<h1 className="environment-title">Video playback environment confirmation</h1>
							{systemRequirements && Object.keys(systemRequirements).length ? 
								<>
								<p className="environment-text">We recommend using the following web browsers.</p>
								<h2 className="environment-title2">System Requirements</h2>
								<dl className="environment-info">
								{systemRequirements.Windows || systemRequirements.Mac ? (
									<>
									<div className="environment-info__title">【PC】</div>
									{systemRequirements.Windows ? 
										<>
										<div className="environment-info__title">Windows {systemRequirements.Windows.os}</div>
										{systemRequirements.Windows.browserEnList.map((browser,index) => {
											return (<dd className="environment-info__text" key={index}>・{browser}</dd>)
										})}
										</>
									: ''}
									{systemRequirements.Mac ? 
										<>
										<div className="environment-info__title">macOS Ventura({systemRequirements.Mac.os} or later)</div>
										{systemRequirements.Mac.browserEnList.map((browser,index) => {
											return (<dd className="environment-info__text" key={index}>・{browser}</dd>)
										})}
										</>
									: ''}
									</>
								) : ('')}
								{systemRequirements.Android || systemRequirements.iOS || systemRequirements.iPad ? (
									<>
									<div className="environment-info__title">【Smart Phone】</div>
									{systemRequirements.Android ? 
										<>
										<div className="environment-info__title">Android （Android {systemRequirements.Android.os} or later）</div>
										{systemRequirements.Android.browserEnList.map((browser,index) => {
											return (<dd className="environment-info__text" key={index}>・{browser}</dd>)
										})}
										</>
									: ''}
									{systemRequirements.iOS && systemRequirements.iPad ? 
										<>
										<div className="environment-info__title">Apple（iOS {systemRequirements.iOS.os} or later、iPadOS {systemRequirements.iPad.os} or later）</div>
										{systemRequirements.iOS.browserEnList.map((browser,index) => {
											return (<dd className="environment-info__text" key={index}>・{browser}</dd>)
										})}
										</>
									: ''}
									</>
								) : ('')}
								</dl>
								<p className="environment-attention">*This site may not be displayed correctly even in the recommended environment, depending on the settings of your web browser.</p>
								<p className="environment-attention">*This website may take time to display or may not operate properly due to communication conditions, communication capacity, or PC specifications.</p>
								<p className="environment-attention">※The app is no longer available.</p>
								
								<div id="pl_programme_info_text" className="hidden_programme">
									<p>If a program list is available, it will be displayed here.</p>
								</div>
								</>
							: ''}
						</div>
						<aside className="environment-side">
							<h2 className="environment-title2">About JavaScript</h2>
							<p className="environment-text">JavaScript is used in this website. If JavaScript is disabled in your browser, the site may not function or display properly. Please enable JavaScript in your browser settings when viewing this site.</p>
							<h2 className="environment-title2">About Cookies</h2>
							<p className="environment-text">Cookies are used on this website. If the cookie function is disabled in your browser, the site may not function or display properly. Please enable cookies in your browser settings when viewing this site.</p>
						</aside>
					</div>
				</section>
			)}
		</>
	);
}

const mapStateToProps = state => {
	return {
		language: state.piano.language,
		donePageLoading: state.offer.donePageLoading,
	};
};

const mapDispatchToProps = dispatch => ({
	setIsStreaming: state => dispatch(setIsStreaming(state)),
	donePageLoading: state => dispatch(donePageLoading(state)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmVideo);
